import { useState } from "react";
import ReactPlayer from "react-player";
import Title from "../components/ui/Title";
import Button from "../components/ui/Button";
import ReactGA from "react-ga4";
import '../styles/pages/media.scss';
import { Link } from "react-router-dom";

const Wallpapers = () => {
  
  const [section, setSection] = useState("wallpapers")

    return (
        <div className="page-container"
            style={{paddingBottom: '50px'}}
        >
            <Title text="MEDIA"/>

            <div className="button-list">
                <Link to={`/gallery`}>
                  <Button type="solid" text="Trailers" color={`media ${section === "trailers" && "media-nav_active"}`}/>
                </Link>
                <Link to={`/gallery/wallpapers`}>
                
                </Link>
                <Button type="solid" text="Wallpapers" color={`media ${section === "wallpapers" && "media-nav_active"}`} />
            </div>
          
                    <div className="main-container">
                <div className="outline">
                    <h1 className="product-title">
                        Wallpapers
                    </h1>
                    <div className="product-pair">
                        <img src={`${process.env.PUBLIC_URL}/img/wallpaper/medium/Azure_Medium-Wallpaper-1.jpg`} alt="Wallpaper 1" />
                        <div className="product-links">
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/mobile/Azure_Mobile-Wallpaper-1.jpg`} download>
                                <Button text="Mobile" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 1 - Mobile',
                                        action: 'Click',
                                        label: `Download - 1 - Mobile`
                                    })     
                                }}/>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/medium/Azure_Medium-Wallpaper-1.jpg`} download>
                                <Button text="2560x1600" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 1 - Medium',
                                        action: 'Click',
                                        label: `Download - 1 - Medium`
                                    })     
                                }}/>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/large/Azure_Large-Wallpaper-1.jpg`} download>
                                <Button text="3840x2160" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 1 - Large',
                                        action: 'Click',
                                        label: `Download - 1 - Large`
                                    })     
                                }}/>
                            </a>
                        </div>
                    </div>
                    <div className="product-pair">
                        <img src={`${process.env.PUBLIC_URL}/img/wallpaper/medium/Azure_Medium-Wallpaper-2.jpg`} alt="Wallpaper 2" />
                        <div className="product-links">
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/mobile/Azure_Mobile-Wallpaper-2.jpg`} download>
                                <Button text="Mobile" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 2 - Mobile',
                                        action: 'Click',
                                        label: `Download - 2 - Mobile`
                                    })     
                                }}/>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/medium/Azure_Medium-Wallpaper-2.jpg`} download>
                                <Button text="2560x1600" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 2 - Medium',
                                        action: 'Click',
                                        label: `Download - 2 - Medium`
                                    })     
                                }}/>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/large/Azure_Large-Wallpaper-2.jpg`} download>
                                <Button text="3840x2160" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 2 - Large',
                                        action: 'Click',
                                        label: `Download - 2 - Large`
                                    })     
                                }}/>
                            </a>
                        </div>
                    </div>
                    <div className="product-pair">
                        <img src={`${process.env.PUBLIC_URL}/img/wallpaper/medium/Azure_Medium-Wallpaper-3.jpg`} alt="Wallpaper 3" />
                        <div className="product-links">
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/mobile/Azure_Mobile-Wallpaper-3.jpg`} download>
                                <Button text="Mobile" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 3 - Mobile',
                                        action: 'Click',
                                        label: `Download - 3 - Mobile`
                                    })     
                                }}/>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/medium/Azure_Medium-Wallpaper-3.jpg`} download>
                                <Button text="2560x1600" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 3 - Medium',
                                        action: 'Click',
                                        label: `Download - 3 - Medium`
                                    })     
                                }}/>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/img/wallpaper/large/Azure_Large-Wallpaper-3.jpg`} download>
                                <Button text="3840x2160" type="solid" onClick={()=>{
                                    ReactGA.event({
                                        category: 'Download - 3 - Large',
                                        action: 'Click',
                                        label: `Download - 3 - Large`
                                    })     
                                }}/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            </div>




           
    )
}

export default Wallpapers;